// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1TvtM{color:#2a343e;font-size:16px;font-weight:400;line-height:24px;text-align:center;-ms-flex-item-align:stretch;align-self:stretch;margin-bottom:16px}", ""]);
// Exports
exports.locals = {
	"intro": "_1TvtM"
};
module.exports = exports;
